import { useLayoutEffect } from 'react'

export default function useHeroViewport(ref) {
  useLayoutEffect(() => {
    const hero = ref.current?.closest('.hero')
    if (!hero) return
    const header = document.querySelector('.site-header')
    const inner = hero.querySelector('.hero-inner')
    let frame
    let active = true

    function measure() {
      const viewport = window.visualViewport?.height ?? window.innerHeight
      const headerHeight = header?.getBoundingClientRect().height ?? 0
      const style = getComputedStyle(inner)
      const top = parseFloat(style.paddingTop)
      const bottom = parseFloat(style.paddingBottom)
      const available = viewport - headerHeight - top - bottom - 12
      const originalHeight = Math.max(0, Math.floor(Math.min(viewport * 0.7 - top - bottom, available))) + top + bottom
      const progress = Math.max(0, Math.min(1, (window.innerWidth - 390) / (1920 - 390)))
      const heroStyle = getComputedStyle(hero)
      const mobileSpacing = parseFloat(heroStyle.getPropertyValue('--hero-mobile-spacing'))
      const desktopSpacing = parseFloat(heroStyle.getPropertyValue('--hero-desktop-spacing'))
      const mobileOriginalHeight = Math.max(0, Math.floor(Math.min(viewport * .7 - mobileSpacing, viewport - headerHeight - mobileSpacing - 12))) + mobileSpacing
      const mobileHeight = Math.max(0, Math.floor(mobileOriginalHeight * 2 / 3) - mobileSpacing)
      const desktopHeight = Math.max(0, Math.floor(Math.min(viewport * .7 - desktopSpacing, viewport - headerHeight - desktopSpacing - 12)))
      const artworkHeight = window.innerWidth <= 390
        ? Math.max(0, Math.floor(originalHeight * 2 / 3) - top - bottom)
        : Math.floor(mobileHeight + (desktopHeight - mobileHeight) * progress)
      hero.style.setProperty('--hero-mobile-artwork-height', `${mobileHeight}px`)
      hero.style.setProperty('--hero-artwork-height', `${artworkHeight}px`)
      hero.style.setProperty('--hero-viewport-height', `${viewport}px`)
    }

    function schedule() {
      if (!active) return
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(measure)
    }

    measure()
    const observer = new ResizeObserver(schedule)
    if (header) observer.observe(header)
    window.addEventListener('resize', schedule)
    window.visualViewport?.addEventListener('resize', schedule)
    document.fonts?.ready.then(schedule)
    return () => {
      active = false
      cancelAnimationFrame(frame)
      observer.disconnect()
      window.removeEventListener('resize', schedule)
      window.visualViewport?.removeEventListener('resize', schedule)
    }
  }, [ref])
}
